module.exports = __webpack_public_path__ + "static/media/30.649e809d.mp3";